module.exports = __webpack_public_path__ + "static/media/collection.cf585fef.png";